//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 21/03/2025
// Version       : 1
// Description   : Guardar nuevo proveedor colocando su nombre
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  TextField,
  Stack,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AgregarProveedor(props) {
  const [datosProveedor, setDatosProveedor] = useState({
    proveedor: null,
  });

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  //*************************************************************************************************************************************/

  // DESHABILITAR BOTON AL GUARDAR
  const [disBtn, setDisBtn] = useState(false);

  //*************************************************************************************************************************************/

  //Función GUARDAR
  const guardarCrear = async (e) => {
    console.log("Estoy por guardar");
    setDisBtn(true);
    e.preventDefault();

    await fetch(UrlApi + "/proveedores_combustible", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        proveedor: datosProveedor.proveedor,
        estado: 1,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El proveedor se guardó exitosamente!");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el proveedor");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const almacenar = (e) => {
    setDatosProveedor({
      ...datosProveedor,
      [e.target.name]: e.target.value,
    });
  };

  //  ------------------------------------------------------------------------

  // Cierre de la notificación
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setDisBtn(false);

    // Acciones de cierre de diálogo y actualización después de que el Snack se cierre
    props.onProveedorGuardado(); // Función para obtener valores de nuevo en el componente padre
    props.handleCloseAgregarProveedor();
  };

  return (
    <>
      <Box
        sx={{
          border: "2px solid #2B76A6",
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            mt: 0,
            mb: 3,
            display: "flex",
            justifyContent: "flex-start", // alineado a la izquierda
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{
              backgroundColor: "#2B76A6",
              borderBottomRightRadius: "12px", // solo esquina inferior derecha
              padding: "8px 18px",
            }}
          >
            Agregar Proveedor
          </Typography>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={guardarCrear}>
            <Grid container spacing={2}>
              <Grid item xs={12} mt={1}>
                <TextField
                  label="Nombre"
                  fullWidth
                  required
                  size="small"
                  name="proveedor"
                  autoComplete="off"
                  value={datosProveedor.proveedor}
                  onChange={almacenar}
                />
              </Grid>

              {/* BOTONES EN LÍNEA */}
              <Grid item xs={12} mt={3}>
                <Box display="flex" justifyContent="space-between">
                  <Button
                    variant="contained"
                    color="error"
                    onClick={props.handleCloseAgregarProveedor}
                  >
                    Volver
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={disBtn}
                  >
                    Guardar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Box>

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AgregarProveedor;
